/**
 * Gestion du modal de création d'événement
 */

/**
 * Initialise le modal de création d'événement
 */
export function initCreateEventModal() {
  const createEventBtn = document.getElementById('create-event-btn');
  const modal = document.getElementById('create-event-modal');
  const closeBtn = document.getElementById('close-create-event-modal');
  const cancelBtn = document.getElementById('cancel-create-event');

  if (!createEventBtn || !modal || !closeBtn) {
    console.error('Éléments du modal de création d\'événement non trouvés');
    return;
  }

  // Ouvrir le modal
  createEventBtn.addEventListener('click', () => {
    modal.style.display = 'flex';

    // Focus sur le premier champ
    const startDateInput = document.getElementById('event-start');
    if (startDateInput) {
      startDateInput.focus();
    }
  });

  // Fermer avec le bouton X
  closeBtn.addEventListener('click', () => {
    closeModal('create-event-modal');
  });

  // Fermer avec le bouton Annuler
  if (cancelBtn) {
    cancelBtn.addEventListener('click', () => {
      closeModal('create-event-modal');
    });
  }

  // Fermer en cliquant en dehors
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal('create-event-modal');
    }
  });

  // Empêcher la fermeture sur le contenu
  const modalContent = modal.querySelector('.modal-content');
  if (modalContent) {
    modalContent.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }
}